import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig';
import api from 'src/actions/api';

class ContactForm extends React.Component {
  componentWillMount() {
    const initialState = {
      email: '',
      name: '',
      message: '',
      captcha: ''
    };
    this.setState(initialState);
  }

  submit = (e) => {
    e.preventDefault();
    if (this.props.contactUs.loading) {
      return;
    }
    const { email, name, message, captcha } = this.state;
    if (!email || !name || !message) {
      return;
    }
    this.props.api('auth/contact', {
      email,
      name,
      message
    });
    alert('Message sent');
    this.props.toggleContacts();
  };

  handleChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  };

  render() {
    let error = this.props.contactUs.error || this.state.error || '';

    return (
      <form
        onSubmit={this.submit}
        class='box p-3 border rounded mb-2 login-form-height contact-form'
      >
        <h4 class='signup-title mb-3'>Contact</h4>
        <div>Herodot SRL, Bucharest, Romania, 061000, Sector 6</div>

        <div class='form-group'>
          <input
            name='email'
            type='email'
            autoComplete='email'
            required
            class='form-control form-control-lg'
            placeholder='Your Email'
            value={this.state.email}
            onChange={this.handleChange}
          />
        </div>
        <div class='form-group'>
          <input
            name='name'
            type='text'
            autoComplete='name'
            required
            class='form-control form-control-lg'
            placeholder='Name'
            value={this.state.name}
            onChange={this.handleChange}
          />
        </div>
        <div class='form-group'>
          <textarea
            name='message'
            required
            class='form-control form-control-lg'
            placeholder='Message'
            value={this.state.message}
            onChange={this.handleChange}
          />
        </div>

        {error && (
          <small id='passwordHelp' class='form-text text-muted mb-2'>
            {error}
          </small>
        )}
        {!this.props.contactUs.loading && (
          <button type='submit' class='btn btn-lg primary login-submit'>
            Send
          </button>
        )}
        {this.props.contactUs.loading && <small>Sending...</small>}
      </form>
    );
  }
}

export default connect(
  function (state) {
    return {
      contactUs: state.api.auth_contact || state.api.initial
    };
  },
  { api }
)(ContactForm);
